/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home__Hero__CtaInputs */

const en_home__hero__cta = /** @type {(inputs: Home__Hero__CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join to play`)
};

/**
* | output |
* | --- |
* | "Join to play" |
*
* @param {Home__Hero__CtaInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home__hero__cta = /** @type {((inputs?: Home__Hero__CtaInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home__Hero__CtaInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home__hero__cta(inputs)
});